function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var _require = require('leaflet-geosearch'),
  OpenStreetMapProvider = _require.OpenStreetMapProvider;
var CustomOSMProvider = /*#__PURE__*/function (_OpenStreetMapProvide) {
  _inherits(CustomOSMProvider, _OpenStreetMapProvide);
  var _super = _createSuper(CustomOSMProvider);
  function CustomOSMProvider() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, CustomOSMProvider);
    _this = _super.call(this, options);
    var host = 'https://nominatim.openstreetmap.org';
    _this.searchUrl = options.searchUrl || "".concat(host, "/search");
    _this.reverseUrl = options.reverseUrl || "".concat(host, "/reverse");
    return _this;
  }
  _createClass(CustomOSMProvider, [{
    key: "endpoint",
    value: function endpoint(_ref) {
      var query = _ref.query,
        type = _ref.type,
        country = _ref.country,
        postalcode = _ref.postalcode;
      var params = typeof query === 'string' ? {
        q: query
      } : query;
      params.format = 'jsonv2';
      params.countrycodes = country;
      params.postalcode = postalcode;
      switch (type) {
        // RequestType.REVERSE === 1
        case 1:
          return this.getUrl(this.reverseUrl, params);
        default:
          return this.getUrl(this.searchUrl, params);
      }
    }
  }, {
    key: "parse",
    value: function parse(response) {
      var records = Array.isArray(response.data) ? response.data : [response.data];
      return records.map(function (r) {
        return {
          x: Number(r.lon),
          y: Number(r.lat),
          label: r.display_name,
          bounds: [[parseFloat(r.boundingbox[0]), parseFloat(r.boundingbox[2])],
          // s, w
          [parseFloat(r.boundingbox[1]), parseFloat(r.boundingbox[3])] // n, e
          ],

          raw: r
        };
      });
    }
  }, {
    key: "getParamString",
    value: function getParamString() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var set = Object.assign({}, this.options.params, params);
      return Object.keys(set).filter(function (key) {
        return !!set[key];
      }).map(function (key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(set[key]));
      }).join('&');
    }
  }, {
    key: "getUrl",
    value: function getUrl(url, params) {
      return "".concat(url, "?").concat(this.getParamString(params));
    }
  }, {
    key: "search",
    value: function search(options) {
      var _this2 = this;
      return new Promise(function (resolve) {
        var url = _this2.endpoint({
          query: options.query,
          // RequestType.SEARCH === 0
          type: 0,
          country: options.country,
          postalcode: options.postalcode
        });
        return resolve(fetch(url));
      }).then(function (request) {
        return request.json();
      }).then(function (json) {
        return _this2.parse({
          data: json
        });
      });
      ;
    }
  }]);
  return CustomOSMProvider;
}(OpenStreetMapProvider);
module.exports = CustomOSMProvider;